// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__bfq8R","logo":"Header_logo__2Gg29","nav":"Header_nav__DlS2r","nav__item":"Header_nav__item__HmTcT","nav__link":"Header_nav__link__3fqUl"};